import { useModal } from "../../../hooks/useModal";
import { cache } from "../../../utils";
import { User } from "../../../stores/useUserStore";
import ChangePinModal from "./ChangePinModal";
import CreatePinModal from "../../auth/CreatePin";

export default function PinSettings() {
  const { isOpen, openModal, closeModal } = useModal();
  const cachedUser = cache.get("USER") as User | null;
  const hasPin = !!cachedUser?.hasPin;

  const handleSuccess = () => {
    if (cachedUser) {
      cache.set("USER", { ...cachedUser, hasPin: true });
    }
  };

  return (
    <>
      <div className="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
        <div className="flex flex-col items-center gap-6 lg:flex-row lg:justify-between">
          <div className="w-full text-center lg:text-left lg:w-auto">
            <h4 className="text-lg font-semibold text-gray-800 dark:text-white/90">
              {hasPin ? "Change PIN" : "Set Transaction PIN"}
            </h4>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {hasPin
                ? "Update your transaction PIN"
                : "Create a PIN to authorize transactions"}
            </p>
          </div>

          <button
            onClick={openModal}
            className="flex w-full items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
          >
            {hasPin ? "Change PIN" : "Add PIN"}
          </button>
        </div>
      </div>

      {hasPin ? (
        <ChangePinModal
          isOpen={isOpen}
          onClose={closeModal}
          onSuccess={handleSuccess}
        />
      ) : (
        <CreatePinModal
          isOpen={isOpen}
          onClose={closeModal}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
}